import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    error: {
        color: `${theme.palette.error.main} !important`,
    },
    select: {
        textAlign: "left",
    },
}));
